export function normaliseAnswer(value) {
  return String(value ?? '')
    .normalize('NFKC')
    .toLocaleLowerCase('en')
    .replace(/[“”‘’]/g, "'")
    .replace(/[^\p{L}\p{N}'-]+/gu, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function shuffle(items, random = Math.random) {
  const result = [...items];
  for (let index = result.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(random() * (index + 1));
    [result[index], result[swapIndex]] = [result[swapIndex], result[index]];
  }
  return result;
}

export function sample(items, count) {
  return shuffle(items).slice(0, Math.min(count, items.length));
}

export function replaceBlank(text, replacement = '__________') {
  return String(text ?? '').replaceAll('{{blank}}', replacement);
}

export function joinPath(base, relative) {
  if (relative.startsWith('/')) return relative;
  const directory = base.split('/').slice(0, -1).join('/');
  return [...directory.split('/'), ...relative.split('/')]
    .filter(Boolean)
    .reduce((parts, part) => {
      if (part === '..') parts.pop();
      else if (part !== '.') parts.push(part);
      return parts;
    }, [])
    .join('/');
}

export function percentage(score, maximum) {
  if (!maximum) return 0;
  return Math.round((score / maximum) * 100);
}

export function countWords(value) {
  return String(value ?? '').trim().split(/\s+/u).filter(Boolean).length;
}

export function hasExactlyOneSentence(value) {
  const cleaned = String(value ?? '').trim();
  if (!cleaned) return false;
  return (cleaned.match(/[.!?]+(?=\s|$)/g) ?? []).length <= 1;
}

export function scrollToTop() {
  if (typeof window === 'undefined') return;
  window.requestAnimationFrame(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  });
}
